import script from "./ReportsNew.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsNew.vue?vue&type=script&setup=true&lang=js"

import "./ReportsNew.vue?vue&type=style&index=0&id=737db698&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-737db698"]])

export default __exports__